// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"e8df59b0","346":"26ba6532","370":"04d90547","539":"c7a981fb","552":"fcaaca58","983":"61e8f0c7"}[chunkId] + ".chunk.js";
};